(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4452],{

/***/ 4452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutWidget013": function() { return /* binding */ LayoutWidget013; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91929);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87900);
/* harmony import */ var _LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15440);
/* harmony import */ var _LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var LayoutWidget013 = function(param) {
    var payload = param.payload;
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$)().t;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().pathname;
    var ref1;
    var link = (ref1 = pathname.substring(1).split("/")[0]) !== null && ref1 !== void 0 ? ref1 : "/";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
            className: (_LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4___default().inner),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .PageLink */ .H_, {
                slug: link,
                className: (_LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4___default().link),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                            className: (_LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                            name: "arrow_slider_prev"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_3__/* .Paragraph */ .nv, {
                        className: (_LayoutWidget013_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                        color: "dark",
                        uppercase: true,
                        children: t(title)
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LayoutWidget013);


/***/ }),

/***/ 15440:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget013_wrapper__yFZXV","title":"LayoutWidget013_title__kZgnp","icon":"LayoutWidget013_icon__THKhY","arrow":"LayoutWidget013_arrow__7ZRxo","link":"LayoutWidget013_link__ElsiK"};

/***/ })

}]);